import { Toast } from '@seiue/ui'
import axios from 'axios'
import { FileDirName, TokenRes, fileApi } from 'packages/sdks-next/growp'

/**
 * 上传文件
 *
 * @param param0 - 参数
 * @param param0.file - 文件
 * @param param0.dirname - 文件夹名
 * @returns oss token
 */
export const uploadFile = async ({
  file,
  dirname,
  showErrModal = true,
}: {
  file: File
  dirname: FileDirName
  showErrModal?: boolean
}): Promise<{ data: TokenRes | undefined; loading: boolean }> => {
  let loading = true
  const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
  const { data } = await fileApi.getOssSignature(ext, dirname)
  let res: TokenRes | undefined = data

  const formData = new FormData()

  for (const key in data) {
    formData.append(key, data[key as keyof typeof data])
  }

  // file 必须放在最后面
  formData.append('file', file)
  await axios
    .post(data.host, formData, {
      headers: {
        'x-oss-object-acl': 'public-read',
        'X-Requested-With': '',
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': 'inline',
      },
    })
    .then(() => {
      loading = false
    })
    .catch((e) => {
      res = undefined
      showErrModal && Toast.error('文件上传失败')
      loading = false
    })

  return { data: res, loading }
}
